import apiRequestActionCreator from './apiRequestActionCreator';

export function fetchVersion() {
    return apiRequestActionCreator({
        actionName: 'VERSION',
        params: {
            baseURL: '',
            url: `/version.json?v=${__APP_VERSION__}`,
        },
    });
}
